<template>
  <div class="animated fadeIn">
    <b-card>
      <p class="h2">利用者情報</p>
      <p> 利用者情報を表示します。</p>
      <div>
      <form @submit.prevent="startSearch()">
        <b-form-group>
          <b-input-group>
            <b-form-input type="text" v-model="serachInputText" placeholder="会社IDを検索"></b-form-input>
            <!-- <b-button variant="primary" @click="startSearch()">
              <i class="fa fa-search"></i> 検索
            </b-button>
            <b-button variant="primary" style="margin-left:10px;" @click="refresh()">
              <i class="fa fa-refresh"></i> 更新
            </b-button> -->
            <b-button variant="primary" @click="dwonloadCSV()" style="margin-left:10px;">
            <i class="fa fa-cloud-download"></i> CSVダウンロード
            </b-button>
          </b-input-group>
        </b-form-group>
      </form>
      </div><br>
      <div>
        <table class="table-sm table-striped table-borderless">
          <thead style="border:solid 0px;">
            <tr>
              <th>会社ID</th>
              <th>公開数</th>
              <th>保存数</th>
              <th>総DL数</th>
              <th width="140">最終ログイン時間</th>
            </tr>
          </thead>
          <tbody>
           <tr v-for="item in getItems()" :key="item.companyid">
            <td><router-link :to="{ name: '利用者ログ情報', params: { userid: item.companyid }}">{{ item.companyid }}</router-link></td>
            <td>{{ item.countpublic }}</td>
            <td>{{ item.countuplaod }}</td>
            <td>{{ item.countdownload }}</td>
            <td>{{ item.lastlogintime }}</td>
           </tr>
          </tbody>
        </table>
      </div>
      <div>
        <spinner v-show="isLoading" :line-size="4" :size="60" :speed="0.8" line-fg-color="#B23E53" style="margin:10px;"></spinner>
      </div>
    </b-card>
  </div>
</template>

<script>
import Store from '@/store'
import ApiAccess from '@/components/ApiAccess'
import Spinner from 'vue-simple-spinner'

export default {
  name: 'tables',
  mixins: [ ApiAccess ],
  components: {
    Spinner
  },
  data: () => {
    return {
      fields: {
        time: {
          label: '時間',
          sortable: false,
          width: '5px'
        },
        text: {
          label: '履歴',
          sortable: false
        }
      },
      items: [],
      currentPage: 1,
      perPage: 12,
      totalRows: 0,
      isLoading: false,
      searchFlg: true,
      serachInputText: '',
      searchText: '',
      starttime: '2018-07-01',
      endtime: '2018-07-31'
    }
  },
  created: function () {
    this.getDatas()
  },
  methods: {
    getDatas: async function () {
      this.isLoading = true

      var log = await this.$_Api_GetUserList(Store.state.token)
      this.items = log.data
      this.isLoading = false
    },
    async refresh () {
      this.items.length = 0
      await this.getDatas()
    },
    startSearch () {
      if (this.serachInputText === '') {
        this.searchFlg = false
        this.searchText = ''
      } else {
        this.searchFlg = true
        this.searchText = this.serachInputText
      }
    },
    getItems () {
      if (this.searchFlg) {
        var searchItems = []
        for (var i = 0; i < this.items.length; i++) {
          if (this.items[i].companyid.toLowerCase().indexOf(this.serachInputText.toLowerCase()) >= 0) {
            searchItems.push(this.items[i])
          }
        }
        return searchItems
      } else {
        return this.items
      }
    },
    dwonloadCSV () {
      var csv = '\ufeff' + '会社ID,公開数,保存数,総DL数,最終ログイン時間\n'
      this.getItems().forEach(el => {
        var line = el['companyid'] + ',' + el['countpublic'] + ',' + el['countuplaod'] + ',' + el['countdownload'] + ',' + el['lastlogintime'] + '\n'
        csv += line
      })
      let blob = new Blob([csv], { type: 'text/csv' })
      let link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = '利用者情報.csv'
      link.click()
    }
  }
}
</script>

<style>
table{
  width: 100%;
}
th {
  background: #3e515b;
  color: white;
}
a:link { color:#23527c; }
a:visited { color: #23527c; }
</style>



// WEBPACK FOOTER //
// src/views/home/UserInfo.vue